<template>
  <aha-modal
    :title="title_importFromSpreadsheet"
    classes="mb-6"
    @hide="hide()"
  >
    <div class="pb-4">
      {{ $i18nPresenter.t('MS Excel, Libre Office, Google Sheets and Numbers') }}
      <div>
        1.
        <a
          class="text-primary-90 text-decoration"
          href="https://s3.amazonaws.com/public.ahaslide.com/template-sheet/ahaslides-quiz-template.xlsx"
          download
          @click="handleDownloadTemplate"
        >{{ $i18nPresenter.t('Download our template') }}</a>
      </div>
      <div>2. {{ $i18nPresenter.t('Fill it out and save as .xlsx') }}</div>
    </div>

    <div class="tab-content">
      <label
        for="upload-file"
        class="text-center"
      >
        <div v-if="importStatus == 1">
          <div
            v-if="importError"
            class="px-3 text-red-100 error-text"
            v-html="importError"
          />

          <div>
            <div class="py-2">
              <p class="pb-1">3. {{ $i18nPresenter.t('Drag and drop here (Max file size:1MB)') }}</p>
              <p>{{ $i18nPresenter.t('or') }}</p>
            </div>
          </div>
        </div>

        <div
          v-if="importStatus == 2 || importStatus == 3"
          class="text-center"
        >
          <p v-if="importStatus == 2" class="text-lg font-bold">{{ $i18nPresenter.t('Uploading...') }}</p>
          <p v-if="importStatus == 3" class="text-lg font-bold">{{ $i18nPresenter.t('Import Done!') }}</p>

          <div class="pt-2">
            {{ $i18nPresenter.t('Large presentations may take several minutes to finish. do not close this window') }}
            <br>{{ $i18nPresenter.t('The imported slides will be added to the end of your presentation.') }}
          </div>
        </div>

        <b-form-file
          id="upload-file"
          v-model="file"
          :state="Boolean(file)"
          choose-label="Attachment2"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          drop-placeholder="drop image"
          :file-name-formatter="uploadFile"
          @mouseup.stop
        />
      </label>
      <aha-button v-if="importStatus === 1" @click="handleBrowseFile">
        {{ $i18nPresenter.t('Browse File...') }}
        <b-form-file
          id="upload-file"
          v-model="file"
          :state="Boolean(file)"
          choose-label="Attachment2"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          drop-placeholder="drop image"
          :file-name-formatter="uploadFile"
          @mouseup.stop
        />
      </aha-button>
    </div>
  </aha-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Config from '@/config'
import Socket from '@/socket'
import Utils from '@/util'
import textUtils from '@/utils/textUtil'
import PresentationUtils from '@/utils/presentation'
import EventBus from '@/eventBus'
import eventCategories from '@/constant/eventCategories'
import SlideMixpanelTracker from '@/utils/mixpanel/slide.mixpanel-tracker'

export default {
  data() {
    return {
      file: null,
      importStatus: 1,
      importError: null,
      title_importFromSpreadsheet: this.$i18nPresenter.t('Import AhaSlides from spreadsheet'),
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
  },
  mounted() {
  },
  methods: {
    ...mapActions(['setImportSheetModalStateAction']),
    async uploadFile(files) {
      if (!files || !files.length) return
      const file = files[0]
      this.importError = ''
      if (file && file.size > 1024000) {
        this.importError = this.$i18nPresenter.t('maximumFileSize1M')
        Utils.mixpanelTracking(
          'Presentation',
          'Import .xlsx',
          'Exceed 1MB',
        )
        return
      }

      const ext = file.name.split('.').pop()
      if (ext.indexOf('xlsx') === -1) {
        this.importError = this.$i18nPresenter.t('Could not upload this file (only support file xlsx).')
        Utils.mixpanelTracking(
          'Presentation',
          'Import xlsx',
          'Invalid file type',
        )
        return
      }

      this.importStatus = 2
      const formData = new FormData()
      formData.append('file', file)
      formData.append('socketId', Socket.getSocketId())
      formData.append('fileSize', file.size)
      formData.append('fileName', file.name)
      formData.append('id', this.presentation.id)
      const headers = new Headers()
      headers.append('Content-Type', 'application/x-www-form-urlencoded')
      const url = Config.api.uploadXlsx
      const resp = await this.$http.post(url, formData)
      this.importStatus = 2
      try {
        const respSlides = await this.$http.post(Config.api.importFileSheet, {
          presentationId: this.presentation.id,
          file: resp.body.file.key,
        })
        if (respSlides.body.length) {
          this.$store.state.isNewPresentation = false
          if (!this.presentation.slides[this.presentation.slides.length - 1].id) {
            this.presentation.slides.splice(this.presentation.slides.length - 1, 1)
          }
          this.presentation.slides = this.presentation.slides.concat(respSlides.body)
          setTimeout(() => {
            EventBus.$emit('makeSlideActive', respSlides.body[0])
            this._handleSuggestPresentationTitle(respSlides.body[0])
          }, 500)
        }
        this.importStatus = 3
        this.hide()
        Utils.showToastSuccess(this.$i18nPresenter.t('Import Done!'))
        this.trackUploadFile()
      } catch {
        this.importStatus = 1
        this.importError = this.$i18nPresenter.t('Please recheck your file or contact support')
      }
    },
    trackUploadFile() {
      const slideTracker = new SlideMixpanelTracker(this.presentation, this.$route.name)
      slideTracker.trackCreateNewSlide('Import Spreadsheet', null)
    },
    hide() {
      this.setImportSheetModalStateAction(false)
    },
    handleDownloadTemplate() {
      Utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Download our template',
        'AhaSlides Quiz Template',
      )
    },
    handleBrowseFile() {
      Utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Import Spreadsheet > Browse file',
      )
    },
    _handleSuggestPresentationTitle(slide) {
      const validSlideTitle = slide.title && slide.title.trim()
      let firstSlideTitle = validSlideTitle || null

      if (slide.canvasBlocks && !firstSlideTitle) {
        firstSlideTitle = textUtils.getFirstCanvasBlockContent(slide.canvasBlocks)
      }
      if (firstSlideTitle) {
        PresentationUtils.handleSuggestPresentationTitle(firstSlideTitle)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.tab-content {
  @apply border-2 border-dashed border-primary-90 px-4;
  @apply bg-primary-60 rounded py-8;
  @apply relative text-center;
}
.custom-file {
  @apply absolute inset-0 overflow-hidden opacity-0;
  & ::v-deep .custom-file-input {
    @apply w-full  h-full cursor-pointer;
  }
}

.text-decoration {
  text-decoration: underline;
}

</style>
